import Link from "next/link";
import { Icon } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import { A, Heading, Panel, Separator, Text } from "@nju/ui";

export function ChangePasswordSuccess() {
  return (
    <Panel testId="change-password-success-panel">
      <div className="flex flex-col items-center">
        <Heading font="ttfirs" tone="neutral" variant="h3" weight="bold">
          hasło zmienione
        </Heading>
        <Separator size="s" tone="invisible" />
        <Icon
          className="w-12 h-12 from-tablet:w-[90px] from-tablet:h-[90px]"
          name="lock-alt-incircle-succes"
        />
        <Separator size="xs" tone="invisible" />
        <Text
          align="center"
          size={{
            "@onlyMobile": "s",
            "@fromTablet": "m",
          }}
        >
          Od tej pory możesz się logować do konta nju światłowód, używając
          nowego hasła.
        </Text>
      </div>
      <Separator size="xs" tone="invisible" />
      <div className="flex items-center only-mobile:flex-col justify-center">
        <Link
          href={portalRoutes.mojeKonto.mojProfil.index.get()}
          passHref={true}
        >
          <A
            className="only-mobile:text-center"
            display={{
              "@onlyMobile": "block",
            }}
            size={{
              "@onlyMobile": "s",
              "@fromTablet": "m",
            }}
            variant="primary"
          >
            ok
          </A>
        </Link>
      </div>
    </Panel>
  );
}
